import { render } from "./FieldOfStudyPage.vue?vue&type=template&id=1e133ac9"
import script from "./FieldOfStudyPage.vue?vue&type=script&lang=ts"
export * from "./FieldOfStudyPage.vue?vue&type=script&lang=ts"
script.render = render

export default script